export default "__VITE_ASSET__BR90l22L__"